import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const PERFORMANCE_METRIC_SCHEMA = Object.freeze({});
const RECORD = generateSchema(PERFORMANCE_METRIC_SCHEMA);
const KEYS: any = generateKeys(PERFORMANCE_METRIC_SCHEMA);

export class PerformanceMetricTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.performance_metric;
  }

  get properties() {
    return this.toJS();
  }
}
